import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HookService {

  onExportXml = new Subject();
  constructor() {
    (window as any).exportXml = () => {
      this.onExportXml.next();
    }
  }
}
